export const enum PropertyContactedTypeEnum {
  call = 'CALL',
  whatsApp = 'WHATSAPP',
  sms = 'SMS',
  email = 'EMAIL',
  callBack = 'CALL_BACK',
}
